export default "__VITE_ASSET__BJOjcDqO__"